export default __webpack_public_path__ + "static/media/BirthdayIcon.55dcba6c.svg";